import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PageHeader } from "../components/lendx/PageHeader";
import { ContactSection } from "../components/lendx/ContactSection";
import { EnquiryForm } from "../components/lendx/EnquiryForm";
import { scrollToId, applySEO } from "../lib/scroll";

export default function ContactPage() {
  const { hash } = useLocation();

  useEffect(() => {
    applySEO(
      "Contact LendX | Talk to a Finance Expert — +91 98206 89982",
      "Get in touch with LendX for expert loan advisory. Call +91 98206 89982, email connect@lendxpro.com, or submit the enquiry form."
    );
  }, []);

  useEffect(() => {
    if (hash === "#enquiry") {
      const t = setTimeout(() => scrollToId("enquiry"), 400);
      return () => clearTimeout(t);
    }
  }, [hash]);

  return (
    <main data-testid="contact-page">
      <PageHeader
        overline="Contact Us"
        title="Let's Talk About Your Financing Requirement"
        sub="Call, WhatsApp, email, or share your requirement through the form — a LendX finance expert will get back to you."
        testId="contact"
      />
      <ContactSection />
      <EnquiryForm />
    </main>
  );
}
